import React from 'react';
import classNames from 'classnames';
import { Contact } from 'models/Contact';
import ThreeDotsDropdown from 'components/ThreeDotsDropdown';
import useMobileLongClick from 'hooks/useMobileLongClick';
import { useTranslation } from 'react-i18next';
import { getUserFullName, normalizeEmail } from 'utils';
import PencilIcon from 'icons/Pencil.icon';
import TrashIcon from 'icons/Trash.icon';

import './ContactCard.styles.scss';

type ContactCardProps = {
  className?: string;
  isLoading?: boolean;
  contact: Contact;
  isSelected: boolean;
  handleEdit: (contact: Contact) => void;
  handleDelete: (id: string) => void;
  handleOnSelect: () => void;
  handleOnClick?: () => void;
};

const ContactCard: React.FC<ContactCardProps> = (props) => {
  const {
    contact,
    className,
    isSelected,
    handleEdit,
    handleDelete,
    handleOnSelect,
    handleOnClick,
  } = props;

  const { firstName, lastName, email, companyName } = contact;

  const classes = classNames(
    'contact-card',
    { selected: isSelected },
    className,
  );

  const { t } = useTranslation();
  const { handleTouchEnd, handleTouchStart } = useMobileLongClick({
    onSelect: handleOnSelect,
  });

  return (
    <div
      className={classes}
      onTouchStart={handleTouchStart}
      onTouchEnd={handleTouchEnd}
      onTouchMove={handleTouchEnd}
      onClick={handleOnClick}
    >
      <div className="name">
        <p>{getUserFullName(firstName, lastName)}</p>

        <div onClick={(e) => e.stopPropagation()}>
          <ThreeDotsDropdown
            withBorder={false}
            options={[
              {
                label: t('edit'),
                icon: <PencilIcon />,
                onClick: () => handleEdit(contact),
              },
              {
                label: t('delete'),
                icon: <TrashIcon />,
                alert: true,
                onClick: () => handleDelete(contact._id),
              },
            ]}
          />
        </div>
      </div>

      <div className="info">
        {email && <p>{normalizeEmail(email)}</p>}
        {companyName && <p>{companyName}</p>}
      </div>
    </div>
  );
};

export default ContactCard;
